import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App.js';
import { registerServiceWorker } from './ui/sw.js';
import { installNoZoomOnFocus } from './ui/noZoomOnFocus.js';
import { installNoZoomGestures } from './ui/noZoomGestures.js';

/*
 * Before the first render, and outside React. One listener on the document for the whole app, no
 * component owns it, and it has to be armed before anything can focus itself. See
 * `noZoomOnFocus.ts` for why the 16px rule alone did not close this.
 *
 * ORDER MATTERS between these two, and only in one direction. `installNoZoomGestures` writes the
 * viewport once and leaves it; `installNoZoomOnFocus` reads whatever is there when a field takes
 * focus and puts it back on blur. Running the lock FIRST means the focus clamp's idea of "back to
 * normal" is already the locked string, so a tap into a text field cannot quietly hand pinch-zoom
 * back in an app that is meant to have none.
 */
installNoZoomGestures();
installNoZoomOnFocus();

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');
createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
